import loadAttachmentPolicyInfoBars from './loadAttachmentPolicyInfoBars';
import removeInfoBarMessageInCompose from '../actions/removeInfoBarMessage';
import findComposeViewStateById, { IdSource } from '../utils/findComposeViewStateById';
import { refreshSharingTips } from '../utils/refreshSharingTips';
import { AccessIssues, getInfoBarId } from 'owa-attachment-policy';
import { onAttachmentDeleted } from 'owa-attachment-well-data';
import { orchestrator } from 'satcheljs';

orchestrator(onAttachmentDeleted, actionMessage => {
    const composeViewState = findComposeViewStateById(
        actionMessage.parentItemId,
        IdSource.ComposeItem
    );
    if (composeViewState) {
        // clear the attachment issue infobars, and reload based on remaining attachments
        const potentialAccessIssueInfoBarIds = AccessIssues.map(getInfoBarId);
        removeInfoBarMessageInCompose(composeViewState, potentialAccessIssueInfoBarIds);
        loadAttachmentPolicyInfoBars(composeViewState);
        refreshSharingTips(composeViewState);
    }
});
